import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import RegionSelect from '~/app/corporate/core/containers/RegionSelect';


const InlineRegionSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={RegionSelect}
      defaultValue={0}
      optionFilterProp='name'
      useNative={false}
      defaultDisplay='Any Region'
      {...other}
    />
  );
};

InlineRegionSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineRegionSelect.defaultProps = {
  label: 'Regions',
  description: 'Regions to be included'
};

export default memo(InlineRegionSelect);
